import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=ed4951c0&"
import script from "./ListUsers.vue?vue&type=script&lang=js&"
export * from "./ListUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports